<mat-button-toggle *ngFor="let item of items; let i = index"
                   class="w-full my-2 text-xl"
                   #buttonToggle
                   aria-label="Unavailable {{ item.value}} button"
                   [checked]="value === item.value"
                   [aria-label]="'toggle-' + item.value"
                   (click)="onToggle(item.value)">
  {{ item.label | translate }}

  @if (!hideSingleSelectionIndicator) {
    <mat-icon *ngIf="buttonToggle.checked" matSuffix>check</mat-icon>
  }
</mat-button-toggle>
